import { SystemInformation, TextField } from "components/Common"
import { ModuleIds, SAMPLES_DELIVERY_TYPE } from "constant/utility"
import { getAllDeliveries } from "helpers/app-backend"
import { convertDateFormat } from "helpers/utilities"
import { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { Col, Row } from "reactstrap"
import { getDeliveries } from "store/actions"
const RESOURCE = ModuleIds.DeliveryManagement

const ViewMode = ({
  data: {
    deliveryTime,
    typeName,
    handlerUserName,
    targetUserName,
    remark,
    relatedIds,
    type,
  },
  data,
  t,
}) => {
  const [dataRelated, setDataRelated] = useState("")
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getDeliveries())
  }, [dispatch])

  useEffect(() => {
    GetDeliveries(relatedIds)
  }, [relatedIds])

  const GetDeliveries = async relatedIds => {
    if (relatedIds) {
      const dataRelatedID = relatedIds.split(",")
      if (dataRelatedID && dataRelatedID.length > 0) {
        let query = { id: dataRelatedID }
        let res = await getAllDeliveries(query)
        if (res.data && res.data.length > 0) {
          setDataRelated(res.data.map(x => x.deliveryDate).join(","))
        }
      }
    }
  }
  return (
    <Row>
      <Col sm="12">
        <Row>
          <Col sm="6">
            <TextField
              label={t("common:Type")}
              textField={typeName}
              resource={RESOURCE}
              isEdit={false}
            />
          </Col>
          {!(type == SAMPLES_DELIVERY_TYPE.Receipt) &&
            <Col sm="6">
              <TextField
                label={t("Sender Name")}
                textField={handlerUserName}
                resource={RESOURCE}
                isEdit={false}
              />
            </Col>
          }
          <Col sm="6">
            <TextField
              label={t("Delivery Time")}
              textField={convertDateFormat(deliveryTime, "HH:mm DD-MM-YYYY")}
              resource={RESOURCE}
              isEdit={false}
            />
          </Col>
          {!(type == SAMPLES_DELIVERY_TYPE.Delivery) &&
            <Col sm="6">
              <TextField

                label={t("Receiver Name")}
                textField={targetUserName}
                resource={RESOURCE}
                isEdit={false}
              />
            </Col>
          }
          <Col sm="6">
            <TextField
              label={t("common:Remark")}
              textField={remark}
              resource={RESOURCE}
              isEdit={false}
            />
          </Col>
        </Row>
      </Col>
      {/* <Col sm="12" className="px-0">
        <ConfirmInformation t={t} data={data} />
      </Col> */}
      <Col sm="12" className="px-0">
        <SystemInformation t={t} data={data} />
      </Col>
    </Row>
  )
}

export default withTranslation(["deliveryPage", "common"])(ViewMode)
